import type { FullInterventionDefinitionViewModel, InterventionDefinitionViewModel } from '@generated';

export function isFullInterventionDefinition(x: InterventionDefinitionViewModel): x is FullInterventionDefinitionViewModel {
	return 'definitionFormControls' in x;
}
